module.exports = "//img4.xes1v1.com/resources/fe-1v1-pclp/img/moudle1-3.ef26e0da.png";